import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

function AdminRoute({ children }) {
	const { user, loading, isAdmin } = useAuth();

	// Show loading indicator
	if (loading) {
		return <div className="loading-container">Loading...</div>;
	}

	// Redirect to dashboard if not admin
	if (!user || !isAdmin()) {
		return <Navigate to="/" replace />;
	}

	// Render children if admin
	return children;
}

export default AdminRoute;
